import mixx from '../../../../mixin/mixin.js'
import print from 'print-js'

export default {
  mixins: [mixx],
  name: 'tventas',
  data() {
    return {
      tkt: 0,
      loading: false,
      loading_f: false,
      tbv: null,
      filtro_li: false,
      data: [{
        ipgTransactionId: '',
        Nro_Transaccion: '',
        det: '',
        Fecha_Pago: '',
        Fecha_Creado: '',
        Fecha_Creado: '',
        detalle: '',
        Importe_Compra: '',
        Cuotas: '',
        Nro_Cupon: '',
        Nro_Autorizacion: '',
        Nro_Tarjeta: '',
        tarjeta: '',
        expira: '',
        CUSTOMERID: '',
        Control_Transaccion: '',
        Email_Cliente: '',
        campo1: '',
        campo2: '',
        campo3: '',
        usuario: '',
      }],
      f_c: {
        desde: this.date_rest(this.currentdate(), -20),
        hasta: this.currentdate()
      }

    }
  },


  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      'order': [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      dom: 'Bfrtip',
      buttons: ['excelHtml5'],

    })
    $('.box').boxWidget()
  },

  methods: {

    imprimir() {

      printJS({ printable: "tkt", type: 'html', css: ['/static/dist/css/tktp.css','/static/dist/css/tkt.css','/static/bower_components/bootstrap/dist/css/bootstrap.css'] })

    },
    init() {
      this.tkt = 0;
      this.data = [{
        ipgTransactionId: '',
        Nro_Transaccion: '',
        det: '',
        Fecha_Pago: '',
        Fecha_Creado: '',
        Fecha_Creado: '',
        detalle: '',
        Importe_Compra: '',
        Cuotas: '',
        Nro_Cupon: '',
        Nro_Autorizacion: '',
        Nro_Tarjeta: '',
        tarjeta: '',
        expira: '',
        CUSTOMERID: '',
        Control_Transaccion: '',
        Email_Cliente: '',
        campo1: '',
        campo2: '',
        campo3: '',
        usuario: '',
      }];

    },

    setTicket(data) {
      this.tkt = data;
      $("#printtkt").modal("show");
    },
    consultar() {
      this.loading = true
      this.tbv.clear()
      this.init();
      this.$http
        .post('/SERVER/scd/ecash/', {
          'a': 'reporte2',
          'f': this.f_c
        }, {
          withCredentials: true
        })
        .then(response => {
          if (response.data.status === 1) {
            this.data = response.data.data;
            for (let i = 0; i < response.data.data.length; i++) {
              this.tbv.row.add([
                `<button class="btn btn-info" data-id="${i}">Ver</button>`,
                response.data.data[i].Nro_Transaccion,
                response.data.data[i].Fecha_Pago,
                response.data.data[i].Fecha_Creado,
                response.data.data[i].Tipo_Operacion,
                response.data.data[i].Estado,
                response.data.data[i].detalle,
                response.data.data[i].Importe_Compra,
                response.data.data[i].Cuotas,
                response.data.data[i].Cod_Cuota,
                response.data.data[i].Nro_Terminal,
                response.data.data[i].Nro_Cupon,
                response.data.data[i].Nro_Autorizacion,
                response.data.data[i].Motivo,
                response.data.data[i].Nro_Referencia,
                response.data.data[i].Nro_Tarjeta,
                response.data.data[i].tarjeta,
                response.data.data[i].expira,
                response.data.data[i].CUSTOMERID,
                response.data.data[i].Control_Transaccion,
                response.data.data[i].Email_Cliente,
                response.data.data[i].metodo,
                response.data.data[i].campo1,
                response.data.data[i].campo2,
                response.data.data[i].campo3,
                response.data.data[i].usuario

              ]);
              let dt = this;
              $('#ventas tbody').unbind();
              $('#ventas tbody').on('click', 'button', function () {

                dt.setTicket($(this).data('id'));
              });

            }
          }
          this.tbv.draw()
          this.loading = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ecash/operaciones/tventas/tventas.js